//#region Imports
import React, { useEffect, useRef, useState } from "react";
//MUI
import { Box, Button, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import eOpsLogo from "../../images/eops.png";
import excel from "../../images/excel.png";
import mepcoLogo from "../../images/mepcoLogo.png";
import pdf from "../../images/pdf.png";
import print from "../../images/print.png";
import { cfpBaseUrl } from "../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
} from "../../services/Functions";
import { internalIconStyles } from "../../style/common";
import "../../style/common.scss";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
//#endregion

const NewconnectionReports = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [totals, setTotals] = useState({});
  // const [officeCode, setOfficeCode] = useState('');
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [connectionTypes, setConnectionTypes] = useState([]);

  const statusNames = [
    "Document Submission",
    "Document Verification",
    "Arrear Verification",
    "Field Survey & Cost Estimation",
    "Reference No. Allocation",
    "DN Submission",
    "DN Payment Verification",
    "Meter Installation",
    "Ready For Billing",
    "Completed",
  ];

  const handleGoClick = () => {
    handleConfirm(officeCode, dateFrom, dateTo);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;

  // Fetch connection types from API
  useEffect(() => {
    const fetchConnectionTypes = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: "",
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "enc/getConnectionTypes",
          requestOptions
        );
        const result = await response.json();

        if (result.status === "200" && result.data) {
          const types = result.data.map((item) => item.connectionTypeName);
          setConnectionTypes(types);
        }
      } catch (error) {
        console.error("Error fetching connection types:", error);
      }
    };

    if (token) {
      fetchConnectionTypes();
    }
  }, [token]);

  const currentFilters = {
    dateFrom,
    dateTo,
    selectedCompanyCode: code === 10 ? selectedCompanyCode : null,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    officeCode,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    dateFrom,
    dateTo,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    officeCode,
  ]);
  const getStats = async (officeCode, dateFrom, dateTo) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("officeCode", officeCode);
      formdata.append("dateFrom", dateFrom ? dateFrom : "");
      formdata.append("dateTo", dateTo ? dateTo : "");

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "comman/getNewConnectionStats", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            const data = result.data;
            setDateFromDisplay(result.dateFrom);
            setDateToDisplay(result.dateTo);

            const matrix = {};
            const columnTotals = {
              withObjections: {},
              withoutObjections: {},
              total: {},
            };

            // Initialize matrix and column totals with 0s
            statusNames.forEach((statusName) => {
              matrix[statusName] = {
                withObjections: {},
                withoutObjections: {},
                total: {},
              };
              connectionTypes.forEach((connectionType) => {
                matrix[statusName].withObjections[connectionType] = 0;
                matrix[statusName].withoutObjections[connectionType] = 0;
                matrix[statusName].total[connectionType] = 0;

                // Initialize totals to 0
                columnTotals.withObjections[connectionType] = 0;
                columnTotals.withoutObjections[connectionType] = 0;
                columnTotals.total[connectionType] = 0;
              });
            });
            // Fill in the matrix with the actual data
            data.forEach((item) => {
              const statusName = item.newConProgStatusName;
              const connectionType = item.connectionType;

              // Fill in the counts
              matrix[statusName].withObjections[connectionType] =
                item.countWithObjections;
              matrix[statusName].withoutObjections[connectionType] =
                item.countWithoutObjections;
              matrix[statusName].total[connectionType] = item.totalCount;

              // Update totals
              columnTotals.withObjections[connectionType] +=
                item.countWithObjections;
              columnTotals.withoutObjections[connectionType] +=
                item.countWithoutObjections;
              columnTotals.total[connectionType] += item.totalCount;
            });

            setTableData(matrix);
            setTotals(columnTotals);
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
    setViewBackdrop(false);
  };
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `Daily New Connection Summary `
          : `${dateFrom ? convertDate(dateFrom) : "-"} to ${
              dateTo ? convertDate(dateTo) : "-"
            }`;

      // Prepare data for the PDF
      const headers = ["Step", "Type", ...connectionTypes];
      const body = [];

      // Data structure for simulating row span
      statusNames.forEach((status) => {
        body.push([
          status, // "Step" value only for the first row in each block
          "Objected", // Aligning under "Type"
          ...connectionTypes.map(
            (type) => tableData[status]?.withObjections[type] || "-"
          ),
        ]);

        // For "Inprocess" and "Total", just leave the "Step" column empty
        body.push([
          "", // Empty cell for "Step"
          "Inprocess", // Aligning under "Type"
          ...connectionTypes.map(
            (type) => tableData[status]?.withoutObjections[type] || "-"
          ),
        ]);

        body.push([
          "", // Empty cell for "Step"
          "Total", // Aligning under "Type"
          ...connectionTypes.map(
            (type) => tableData[status]?.total[type] || "-"
          ),
        ]);
      });

      // Add the totals row
      const totalRow = ["Total", ""];
      connectionTypes.forEach((type) => {
        totalRow.push(
          totals.total[type] !== undefined ? totals.total[type] : "-"
        );
      });
      body.push(totalRow);

      // Create a new jsPDF instance
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`New Connection Summary for ${officeName}`, pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      // Add table to PDF using autoTable
      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: body,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          fillColor: [255, 255, 255], // White background for body rows
        },
        headStyles: {
          fillColor: "#eeeff1", // Light grey background for header rows
          textColor: "black",
          fontSize: 8,
          fontStyle: "bold",
          halign: "left",
          lineWidth: 0.5,
          lineColor: "white",
        },
        columnStyles: {
          0: { cellWidth: 30 }, // "Step" column
          1: { cellWidth: 30 }, // "Type" column
        },
        theme: "striped", // Alternating row colors for easy reading
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(
          `${officeName}- From ${dateFrom} - to ${dateTo} - New-Connection -Summary.pdf`
        );
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };
  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${officeName}- From ${dateFrom} - to ${dateTo} - New-Connection -Summary.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const handleConfirm = async () => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("officeCode", officeCode);
      formdata.append("dateFrom", dateFrom);
      formdata.append("dateTo", dateTo);

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "comman/getNewConnectionStats",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        const data = result.data;
        setDateFromDisplay(result.dateFrom);
        setDateToDisplay(result.dateTo);

        const matrix = {};
        const columnTotals = {
          withObjections: {},
          withoutObjections: {},
          total: {},
        };

        // Initialize matrix and column totals with 0s
        statusNames.forEach((statusName) => {
          matrix[statusName] = {
            withObjections: {},
            withoutObjections: {},
            total: {},
          };
          connectionTypes.forEach((connectionType) => {
            matrix[statusName].withObjections[connectionType] = 0;
            matrix[statusName].withoutObjections[connectionType] = 0;
            matrix[statusName].total[connectionType] = 0;

            // Initialize totals to 0
            columnTotals.withObjections[connectionType] = 0;
            columnTotals.withoutObjections[connectionType] = 0;
            columnTotals.total[connectionType] = 0;
          });
        });

        // Fill in the matrix with the actual data
        data.forEach((item) => {
          const statusName = item.newConProgStatusName;
          const connectionType = item.connectionType;

          // Fill in the counts
          matrix[statusName].withObjections[connectionType] =
            item.countWithObjections;
          matrix[statusName].withoutObjections[connectionType] =
            item.countWithoutObjections;
          matrix[statusName].total[connectionType] = item.totalCount;

          // Update totals
          columnTotals.withObjections[connectionType] +=
            item.countWithObjections;
          columnTotals.withoutObjections[connectionType] +=
            item.countWithoutObjections;
          columnTotals.total[connectionType] += item.totalCount;
        });

        setTableData(matrix);
        setTotals(columnTotals);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setViewBackdrop(false);
    }
  };

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    console.log(officeCode, "Office Code Printing."),
    (
      <>
        {/* Applications Table */}
        <Box className="form-box">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Box className="application-table" style={{ marginRight: "10px" }}>
              <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                New-Connection Report
              </h3>
              <div className="div-datagrid">
                <div className="reports-container">
                  <div
                    className="filter-fields"
                    style={{
                      width: "75%",
                      justifyContent: "flex-start",
                      gap: "15px",
                    }}
                  >
                    <div className="field-container">
                      <Typography className="field-label">
                        {" "}
                        Date From
                      </Typography>
                      <input
                        type="date"
                        className="date-field"
                        value={dateFrom}
                        onChange={(e) => {
                          setDateFrom(e.target.value);
                        }}
                      />
                    </div>
                    <div className="field-container">
                      <Typography className="field-label"> Date To</Typography>
                      <input
                        type="date"
                        className="date-field"
                        max={new Date().toISOString().split("T")[0]}
                        value={dateTo}
                        onChange={(e) => {
                          setDateTo(e.target.value);
                        }}
                      />
                    </div>
                    {/* Circle Field (Auto-selected) */}
                    {code == 10 && (
                      <div className="field-container">
                        <Typography className="field-label">Company</Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedCompanyCode}
                          onChange={(e) => {
                            handleChangeCompany(e);
                          }}
                        >
                          <option value="10">Select Company</option>
                          <option value="11">LESCO</option>
                          <option value="12">GEPCO</option>
                          <option value="13">FESCO</option>
                          <option value="14">IESCO</option>
                          <option value="15">MEPCO</option>
                          <option value="26">PESCO</option>
                          <option value="27">HAZECO</option>
                          <option value="37">HESCO</option>
                          <option value="38">SEPCO</option>
                          <option value="48">QESCO</option>
                          <option value="59">TESCO</option>
                        </select>
                      </div>
                    )}

                    {hierarchy <= 2 && (
                      <div className="field-container">
                        <Typography className="field-label">Circle</Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={circleCode || ""}
                          onChange={(e) => {
                            handleCircleChange(e);
                          }}
                        >
                          <option value="">All Circle</option>
                          {filteredCircles.map((circle) => (
                            <option
                              key={circle.circleCode}
                              value={circle.circleCode}
                            >
                              {circle.circleName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {hierarchy <= 3 && (
                      <div className="field-container">
                        <Typography className="field-label">
                          Division
                        </Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedDivision || ""}
                          onChange={(e) => {
                            handleDivisionChange(e);
                          }}
                          disabled={!circleCode}
                        >
                          <option value="">All Division</option>
                          {filteredDivisions.map((division) => (
                            <option
                              key={division.divisionCode}
                              value={division.divisionCode}
                            >
                              {division.divisionName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {hierarchy <= 4 && (
                      <div className="field-container">
                        <Typography className="field-label">
                          Sub-Division
                        </Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedSubDivision || ""}
                          onChange={(e) => {
                            handleSubDivisionChange(e);
                          }}
                          disabled={!selectedDivision}
                        >
                          <option value="">All Sub-Division</option>
                          {filteredSubDivisions.map((subDivision) => (
                            <option
                              key={subDivision.subDivisionCode}
                              value={subDivision.subDivisionCode}
                            >
                              {subDivision.subDivisionName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "10px" }}
                      onClick={handleGoClick}
                      disabled={isGoDisabled || viewBackdrop}
                    >
                      Go
                    </Button>
                  </div>
                  <div className="export-button-container">
                    <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                  </div>
                </div>
                <div
                  className="table-container"
                  style={{ marginBottom: "40px" }}
                >
                  <div id="pdf-table">
                    <div style={{ maxHeight: "900px", overflowY: "auto" }}>
                      <table
                        className="table"
                        ref={tableRef}
                        style={{
                          marginBottom: "40px",
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 10,
                          }}
                        >
                          <tr
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "white",
                              zIndex: 3,
                            }}
                          >
                            <th
                              colSpan="16"
                              style={{
                                fontSize: "20px",
                                borderBottom: "2px solid white",
                                textAlign: "center",
                                backgroundColor: "#d5e5ff",
                                color: "black",
                              }}
                            >
                              {dateFrom &&
                              dateTo &&
                              convertDate(dateFrom) === convertDate(dateTo)
                                ? `Daily New Connection Summary for (${officeName})`
                                : `New Connection Summary for (${officeName}) from ${
                                    dateFrom ? convertDate(dateFrom) : "-"
                                  } to ${dateTo ? convertDate(dateTo) : "-"}`}
                            </th>
                          </tr>
                          <tr
                            style={{
                              position: "sticky",
                              top: "37px",
                              backgroundColor: "white",
                              zIndex: 1,
                            }}
                          >
                            <th
                              style={{
                                textAlign: "left",
                                border: "5px solid white",
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              Step
                            </th>
                            <th
                              style={{
                                // width: `${100 / connectionTypes.length}%`,
                                textAlign: "left",
                                border: "5px solid white",
                                // backgroundColor: '#d5e5ff',
                                // color: 'black',
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              Type
                            </th>
                            {connectionTypes.map((type) => (
                              <th
                                style={{
                                  // width: `${100 / connectionTypes.length}%`,
                                  textAlign: "left",
                                  border: "5px solid white",
                                  // backgroundColor: '#d5e5ff',
                                  // color: 'black',
                                  backgroundColor: "#eeeff1",
                                  color: "black",
                                  fontSize: "14px",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                }}
                                key={type}
                              >
                                {type}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {statusNames.map((status) => (
                            <React.Fragment key={status}>
                              <tr key={`${status}-withObjections`}>
                                <td
                                  rowSpan="3"
                                  style={{ width: "150px", textAlign: "left" }}
                                >
                                  {status}
                                </td>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "left",
                                    fontSize: "12px",
                                  }}
                                >
                                  Objected
                                </td>
                                {connectionTypes.map((type) => (
                                  <td key={`${status}-${type}-withObjections`}>
                                    {tableData[status] &&
                                    tableData[status].withObjections[type] !==
                                      undefined
                                      ? tableData[status].withObjections[type]
                                      : "-"}
                                  </td>
                                ))}
                              </tr>
                              <tr key={`${status}-withoutObjections`}>
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "left",
                                    fontSize: "12px",
                                  }}
                                >
                                  Inprocess
                                </td>
                                {connectionTypes.map((type) => (
                                  <td
                                    key={`${status}-${type}-withoutObjections`}
                                  >
                                    {tableData[status] &&
                                    tableData[status].withoutObjections[
                                      type
                                    ] !== undefined
                                      ? tableData[status].withoutObjections[
                                          type
                                        ]
                                      : "-"}
                                  </td>
                                ))}
                              </tr>
                              <tr
                                key={`${status}-totalCount`}
                                style={{ color: "#006ad1" }}
                              >
                                <td
                                  style={{
                                    width: "100px",
                                    textAlign: "left",
                                    fontSize: "12px",
                                  }}
                                >
                                  Total
                                </td>
                                {connectionTypes.map((type) => (
                                  <td key={`${status}-${type}-totalCount`}>
                                    {tableData[status] &&
                                    tableData[status].total[type] !== undefined
                                      ? tableData[status].total[type]
                                      : "-"}
                                  </td>
                                ))}
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ color: "#006ad1" }}>
                            <td rowSpan="3" style={{ textAlign: "left" }}>
                              <strong>Grand Total</strong>
                            </td>
                            <td style={{ textAlign: "left", fontSize: "12px" }}>
                              <strong>Objected</strong>
                            </td>
                            {connectionTypes.map((type) => (
                              <td key={`grand-total-withObjections-${type}`}>
                                <strong>
                                  {statusNames.reduce((total, status) => {
                                    return (
                                      total +
                                      (tableData[status]?.withObjections[
                                        type
                                      ] || 0)
                                    );
                                  }, 0)}
                                </strong>
                              </td>
                            ))}
                          </tr>
                          <tr style={{ color: "#006ad1" }}>
                            <td style={{ textAlign: "left", fontSize: "12px" }}>
                              <strong>Inprocess</strong>
                            </td>
                            {connectionTypes.map((type) => (
                              <td key={`grand-total-withoutObjections-${type}`}>
                                <strong>
                                  {statusNames.reduce((total, status) => {
                                    return (
                                      total +
                                      (tableData[status]?.withoutObjections[
                                        type
                                      ] || 0)
                                    );
                                  }, 0)}
                                </strong>
                              </td>
                            ))}
                          </tr>
                          <tr style={{ color: "#006ad1" }}>
                            <td style={{ textAlign: "left", fontSize: "12px" }}>
                              <strong>Total</strong>
                            </td>
                            {connectionTypes.map((type) => (
                              <td key={`grand-total-total-${type}`}>
                                <strong>
                                  {statusNames.reduce((total, status) => {
                                    return (
                                      total +
                                      (tableData[status]?.total[type] || 0)
                                    );
                                  }, 0)}
                                </strong>
                              </td>
                            ))}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </Box>

        {/* Backdrop */}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={viewBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    )
  );
};

export default NewconnectionReports;
